import type { AllRouteEndpoints } from "../routeTypes";
export const engagementUpdateLocationSetLocationSetIdCacheKeys: AllRouteEndpoints[] = [
  "/engagement/geofences_data(/:location_set_id)",
  "/engagement/location_set_data",
  "/engagement/location_sets_data",
];
